import { Component, OnInit, inject, signal } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MatTableModule } from '@angular/material/table';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MigrationValidationService, MigrationValidationDto } from '../../api/gen';
import { JJamesCardComponent } from 'shared-lib';

@Component({
    selector: 'app-migration-validation',
    standalone: true,
    imports: [
        CommonModule,
        MatTableModule,
        MatProgressSpinnerModule,
        MatIconModule,
        MatButtonModule,
        MatTooltipModule,
        JJamesCardComponent
    ],
    templateUrl: './migration-validation.component.html',
    styleUrl: './migration-validation.component.scss'
})
export class MigrationValidationComponent implements OnInit {
    private migrationValidationService = inject(MigrationValidationService);

    validation = signal<MigrationValidationDto | null>(null);
    isLoading = signal(false);
    hasError = signal(false);

    displayedColumns = ['name', 'description', 'oldDbCount', 'newDbCount', 'difference', 'matchPercent'];

    ngOnInit(): void {
        this.load();
    }

    load(): void {
        this.isLoading.set(true);
        this.hasError.set(false);
        this.migrationValidationService.migrationValidationGet().subscribe({
            next: (result) => {
                this.validation.set(result);
                this.isLoading.set(false);
            },
            error: (err) => {
                console.error('Error loading migration validation:', err);
                this.hasError.set(true);
                this.isLoading.set(false);
            }
        });
    }

    matchClass(matchPercent: number | undefined): string {
        if (matchPercent === undefined) return 'bg-gray-100 text-gray-700';
        if (matchPercent >= 95) return 'bg-green-100 text-green-800';
        if (matchPercent >= 80) return 'bg-yellow-100 text-yellow-800';
        return 'bg-red-100 text-red-800';
    }

    overallClass(matchPercent: number | undefined): string {
        if (matchPercent === undefined) return 'text-gray-600';
        if (matchPercent >= 95) return 'text-green-600';
        if (matchPercent >= 80) return 'text-yellow-600';
        return 'text-red-600';
    }
}
